import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { DarkModeProvider } from './lib/darkMode.tsx';
import { TagsProvider } from './lib/TagsContext.tsx';
import App from './App.tsx';
import './index.css';
import * as Sentry from "@sentry/react";
import { PostHogProvider} from 'posthog-js/react'

const posthogHost =import.meta.env.VITE_PUBLIC_POSTHOG_HOST
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY

Sentry.init({
  dsn: "https://da3151a22569a58bd726cbb5563855e2@o4508931357016064.ingest.us.sentry.io/4508931360817152",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/letterboxxxed\.com\//],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const options = {
  api_host: posthogHost
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider 
      apiKey={posthogKey}
      options={options}
    ></PostHogProvider>
    <DarkModeProvider>
      <TagsProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TagsProvider>
    </DarkModeProvider>
  </StrictMode>
);